<template>
    <div id="aboutUs" class="aboutUs container">
        <div class="col-xs-12 col-md-6" data-aos="fade-right">
            <h1>{{ msg }}</h1>
            <hr>
            <h2>
                We are a company with over 40 years of combined expertise, Our team of professionals are ready to serve you in the United States and Latin America region.
                Our organization has been set up to comply fast and efficiently with our customer’s requirements. 
                Our goal is to create intelligent solutions according to our clients needs, embracing in an integrated way different fields and digital area trends. 
                Thanks to this, we have the great opportunity to develop highly competitive solutions.
            </h2>
        </div>
        <div class="col-xs-12 col-md-6" data-aos="fade-left">
            <img src="../assets/foto2.jpg" width="70%" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'aboutUs',
    data() {
        return {
            msg: 'ABOUT US'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
    font-weight: bold;
    padding-top: 70px;
    color: #333434;
}

h2 {
    margin-bottom: 100px;
    font-size: 11pt;
    text-align: center;
    font-weight: lighter;
    padding: 0px 20px;
    line-height: 16pt;
}

a {
    color: #42b983;
}

hr{
    border-width: 2px;
    width: 20%;
    border-color: #f86d10;
}

.aboutUs {
    height: 100vh;
    padding-top: 300px;
}

@media screen and (max-width: 1450px){
    .aboutUs{
        padding-top: 120px;
    }
}

/* tablet */
@media screen and (max-width: 991px) {
    img{
        width: 50%;
    }

    .aboutUs{
        padding: 0px;
    }
    
    h2{
        text-align: justify
    }
}

/* mobile */
@media screen and (max-width: 767px) {
    img {
        display: none;
    }

    h2{
        padding: 0px;
        text-align: justify;
    }

    .aboutUs{
        height: auto;
    }
}

/*smaller mobile horizontal*/
@media screen and (max-width: 569px){
    
}

/* smaller mobile */
@media screen and (max-width: 323px) {

    h1{
        margin-top: -10px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue